import React from "react";

import { addressValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function RegistrationCity(props: { labelClassName?: string }) {
	const { labelClassName } = props;

	return (
		<FormInputField
			id="townOrCity"
			className="form__field"
			name="city"
			pattern={{
				value: addressValidationPattern,
				message: "registration:CITY_CHARACTER",
			}}
			label="registration:CITY_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:CITY_PLACEHOLDER"
			required
		/>
	);
}
